import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `Currency/CheckValidateCharge/${dossierId}`, method: 'GET', token: token })
}
